import {
  AnalyzeExperimentRequestBodyType,
  ConversionStageReachedType,
  CustomEventsFilterType,
  StatSigViewType,
} from "@intelligems/ig-types";
import { DashboardPageName } from "@src/api/types/dashboards";

export type IExperienceDashboardFilters = Pick<
  AnalyzeExperimentRequestBodyType,
  | "deviceType"
  | "visitorType"
  | "channels"
  | "customEvents"
  | "userBehavior"
  | "urlParam"
  | "landingPage"
  | "countryCodes"
  | "maxZScore"
  | "discountIncludeType"
  | "testOrdersOnly"
  | "startTime"
  | "endTime"
  | "shippingExpensePerOrder"
  | "transactionFeePct"
  | "excludeIpAddresses"
  | "return_variants"
> & {
  experienceId?: string;
  compareGroupA?: string;
  compareGroupB?: string;
  statSigView?: StatSigViewType;
  isZScoreEnabled: boolean;
  pageName: DashboardPageName;
  hiddenEndTime: number | null;
  reachedCheckoutStage: ConversionStageReachedType;
  customEventsFilterType?: CustomEventsFilterType;
};

export const initialDashboardFiltersState: IExperienceDashboardFilters = {
  experienceId: undefined,
  startTime: null,
  endTime: null,
  testOrdersOnly: null,
  compareGroupA: "",
  compareGroupB: "",
  discountIncludeType: 1,
  isZScoreEnabled: true,
  statSigView: "best",
  maxZScore: null,
  customEvents: [],
  countryCodes: [],
  deviceType: "any",
  visitorType: "any",
  shippingExpensePerOrder: null,
  transactionFeePct: null,
  excludeIpAddresses: [],
  channels: [],
  customEventsFilterType: "any",
  urlParam: {
    queryParam: null,
    queryParamValue: null,
    queryParamFilterType: null,
  },
  landingPage: {
    landingPageUrlPath: null,
    landingPageUrlPathFilterType: null,
  },
  userBehavior: {
    viewedCheckout: null,
    addedToCart: null,
    viewedCollectionPage: null,
    viewedProductPage: null,
  },
  pageName: (localStorage.getItem("DashboardFilters.pageName") ??
    "overview") as DashboardPageName,
  hiddenEndTime: null,
  reachedCheckoutStage: "any",
};

export type AnalyticsActiveFilterType = {
  // key: keyof IExperienceDashboardFilters | keyof SitewideDashboardFiltersDialog;
  key: string;
  label: any;
  value: any;
};
